import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../styles/pages/CierreAnual.css';
import { API_BASE_URL } from '../config';


const CierreAnual = ({ token, id_company }) => {
  const [estado, setEstado] = useState([]);
  const fetchEstado = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/cierre-anual`, {
        params: { company: id_company },
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado(res.data);
    } catch (err) {
      console.error('Error al obtener cierre anual:', err);
    }
  };
  useEffect(() => {
    if (id_company && token) fetchEstado();
  }, [id_company, token]);

  const toggleAnio = async (anio, cerrado) => {
    try {
      await axios.post(`${API_BASE_URL}/api/cierre-anual`, {
        company: id_company,
        anio,
        cerrado: !cerrado
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEstado(
        estado.map((e) =>
          e.anio === anio ? { ...e, cerrado: !cerrado } : e
        )
      );
    }  catch (err) {
        console.error('Error al actualizar cierre anual:', err);
        Swal.fire({
          icon: 'error',
          title: 'No se pudo cerrar el año',
          text: err.response?.data || 'Error al cerrar el año'
        });
      }
  };
  return (
    <div className="cierre-anual">
      <h1>Cierre Anual</h1>
      <table className="cierre-table">
        <thead>
          <tr>
            <th>Año</th>
            <th>Cerrado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {estado.map((row) => (
            <tr key={row.anio}>
              <td>{row.anio}</td>
              <td className={row.cerrado ? 'status-true' : 'status-false'}>
                {row.cerrado ? 'Sí' : 'No'}
              </td>
              <td>
                <button onClick={() => toggleAnio(row.anio, row.cerrado)}>
                  Cerrar año
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CierreAnual;